import { useMediaQuery } from "@mui/material";

const ChartContainer = ({ children }) => {

    const upMDScreenSize = useMediaQuery((theme) => theme.breakpoints.up('md'));

    return (
        <div
            style={{ position: 'relative', width: '100%', height: upMDScreenSize ? '50vh' : '40vh', cursor: "crosshair" }}
            onMouseDown={(e) => e.currentTarget.style.cursor = 'grabbing'}
            onMouseUp={(e) => e.currentTarget.style.cursor = 'crosshair'}
            onMouseLeave={(e) => e.currentTarget.style.cursor = 'crosshair'}
        >
            {children}
        </div>
    );
}

export default ChartContainer;